// extracted by mini-css-extract-plugin
module.exports = {"checkText":"src-pages-trade-Protocol-__index-module__checkText--3J0Gb","modalContent":"src-pages-trade-Protocol-__index-module__modalContent--3Q2Ah"};